import { UnizoLoadingIcon } from "./loading/UnizoLoadingIcon";

// 読み込み中表示（画面全体ローディングの正）
// PRODUCT_DEV-583 R7-⑤: 円形スピナー → Unizoアイコンのローディング（画面中央で弾む）に差し替え。
// R9: 文言が必要な画面向けに message prop を追加（アイコン下部の文言のみ差し替え可能）。
// variant の切替は UnizoLoadingIcon.tsx の DEFAULT_UNIZO_LOADING_VARIANT を変更する。
export function Splash({ message = "データを読み込み中..." }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="flex flex-col items-center">
        <UnizoLoadingIcon />
        <p className="text-neutral-600 mt-4">{message}</p>
      </div>
    </div>
  );
}
